if (!window.daz) {
    window.daz = {};
}

function initRegisterForm(registerForm) {
    if (!registerForm || registerForm.dataset.registerValidated === 'true') {
        return;
    }
    registerForm.dataset.registerValidated = 'true';

    const errors = {
        firstname: [],
        lastname: [],
        email: [],
        password: [],
        tos: []
    };

    const firstNameInput = registerForm.querySelector('[name="firstname"]');
    const lastNameInput = registerForm.querySelector('[name="lastname"]');
    const emailInput = registerForm.querySelector('[name="email"]');
    const passwordInput = registerForm.querySelector('[name="password"]');
    const inputsArr = [firstNameInput, lastNameInput, emailInput, passwordInput].filter(Boolean);

    const tosCheckbox = registerForm.querySelector('[name="eula"]');

    const submitBtn = registerForm.querySelector('[type="submit"]');
    const submitBtnLabel = submitBtn ? submitBtn.innerText : 'Submit';

    if (!emailInput || !submitBtn) {
        return;
    }

    // prevent user from typing spaces in email field
    emailInput.addEventListener('keydown', key => {
        if (key.keyCode === 32) key.preventDefault();
    });

    // validation: takes in an individual input field or all input fields
    function validate(inputArr = inputsArr) {
        // disable submit button until validation passed
        submitBtn.setAttribute('disabled', 'true');
        submitBtn.style.opacity = '.5';
        submitBtn.style.cursor = 'not-allowed';

        // handle input fields
        inputArr.forEach(input => {
            const inputName = input.getAttribute('name');

            // reset related errors to build updated list
            errors[inputName] = [];

            // check for entered text
            if (!input.value.trim()) {
                errors[inputName].push('This field is required');
            } else {
                // check email for proper format
                // just checking for something before and after @ symbol
                if (input === emailInput) {
                    const emailArr = input.value.split('@');

                    if (emailArr.length === 2) {
                        for (let i = 0; i < emailArr.length; i++) {
                            if (emailArr[i].trim().length === 0) {
                                errors.email.push('Please enter a valid email');
                                break;
                            }
                        }
                    } else {
                        errors.email.push('Please enter a valid email');
                    }
                }

                // check password for min length of 7
                if (input === passwordInput && input.value.length < 7) {
                    errors.password.push('Password must be at least 7 characters');
                }
            }
        });

        // enable submit button if no input errors
        let errorsFound = false;
        for (let i = 0; i < Object.values(errors).length; i++) {
            if (Object.values(errors)[i].length > 0) {
                errorsFound = true;
                break;
            }
        }

        if (errorsFound === false) {
            submitBtn.removeAttribute('disabled');
            submitBtn.style.opacity = '1';
            submitBtn.style.cursor = 'pointer';

            // for if ran by form submit action
            return true;
        } else {
            // for if ran by form submit action
            return false;
        }
    }

    function showInputErrs(inputArr = inputsArr) {
        inputArr.forEach(input => {
            const inputName = input.getAttribute('name');

            // remove previous error messages shown
            if (registerForm.querySelector(`#err-${inputName}`)) {
                registerForm.querySelector(`#err-${inputName}`).remove();
            }

            if (errors[inputName].length > 0) {
                // build error message elements
                const errContainer = document.createElement('div');
                errContainer.setAttribute('id', `err-${inputName}`);
                errContainer.classList.add('validation-wrap');

                errors[inputName].forEach(errStr => {
                    const errMsg = document.createElement('p');
                    errMsg.classList.add('validation-error');
                    errMsg.innerText = errStr;
                    errContainer.appendChild(errMsg);
                });

                // show error messages in form
                input.parentElement.appendChild(errContainer);
            }
        });
    }

    // listen for input field changes
    // validate individual field after time in ms and on blur
    const validateWaitMs = 1000;
    let validateTimer;

    inputsArr.forEach(input => {
        input.addEventListener('keyup', () => {
            validate([input]);

            validateTimer = setTimeout(() => showInputErrs([input]), validateWaitMs);
        });

        input.addEventListener('keydown', () => {
            validate([input]);

            clearTimeout(validateTimer);
        });

        input.addEventListener('blur', () => showInputErrs([input]));
    });

    if (tosCheckbox) {
        const tosMessage = 'You must check the box above to continue.';

        function syncTosValidity() {
            tosCheckbox.setCustomValidity(tosCheckbox.checked ? '' : tosMessage);
        }

        syncTosValidity();
        tosCheckbox.addEventListener('change', syncTosValidity);
    }

    // listen for form submit and validate user input
    registerForm.addEventListener('submit', (e) => {
        // Always use the AJAX path, but still honor native constraints
        // (required fields, EULA checkbox) for click and Enter submit.
        e.preventDefault();

        if (tosCheckbox) {
            tosCheckbox.setCustomValidity(
                tosCheckbox.checked ? '' : 'You must check the box above to continue.'
            );
        }

        if (!registerForm.checkValidity()) {
            registerForm.reportValidity();
            return;
        }

        const validated = validate();
        if (!validated) {
            showInputErrs();
            return;
        }

        // Let the user know we're working on it
        submitBtn.setAttribute('disabled', 'true');
        submitBtn.style.opacity = '.5';
        submitBtn.style.cursor = 'not-allowed';
        submitBtn.innerText = 'Please wait...';
        // append the loading spinner
        const spinner = `<div class="fixed loading"><img src="/static/images/loading.gif"  alt="loading"/><div>Loading...</div></div>`;
        document.body.insertAdjacentHTML('beforeend', spinner);

        function restoreSubmitState() {
            const loadingEl = document.querySelector('.fixed.loading');
            if (loadingEl) {
                loadingEl.remove();
            }
            submitBtn.removeAttribute('disabled');
            submitBtn.style.opacity = '1';
            submitBtn.style.cursor = 'pointer';
            submitBtn.innerText = submitBtnLabel;
        }

        const action = registerForm.getAttribute('action');
        const formData = new FormData(registerForm);
        formData.append("surl", document.location.pathname);

        // okay... now we need to handle if the is set to no_studio but the form comes in with wants studio checked
        // in that case we will clear the rpid and redirect so they are sent to download the software
        if (formData.get('rpid') === 'no_studio' && formData.get('want-studio') === 'true') {
            formData.delete('rpid');
            formData.delete('redirect');
        }

        fetch(action, {
            method: 'POST',
            body: formData
        }).then(response => {
            return response.json().catch(() => {
                throw new Error(response.ok
                    ? 'Unexpected response from server. Please try again.'
                    : 'Registration failed. Please try again.');
            }).then(data => {
                if (!response.ok) {
                    throw new Error((data && data.error) || 'Registration failed. Please try again.');
                }
                return data;
            });
        }).then(data => {
            if (data.error) {
                restoreSubmitState();
                daz.api.displayErrors([data.error]);
                return;
            }

            if (data.redir_url) {
                window.location.href = data.redir_url;
                return;
            }

            restoreSubmitState();
        }).catch(err => {
            restoreSubmitState();
            const message = (err && err.message) ? err.message : 'Registration failed. Please try again.';
            if (daz.api && daz.api.displayErrors) {
                daz.api.displayErrors([message]);
            } else {
                console.error(message);
            }
        });
    });

    // validate form on page load in case user had input info and left page before submitting
    validate();
}

daz.initRegisterForms = function (root) {
    const scope = root || document;
    const registerForms = scope.querySelectorAll
        ? scope.querySelectorAll('form[name="new-user-registration"]')
        : [];

    registerForms.forEach(initRegisterForm);

    // allow passing a form element directly
    if (root && root.matches && root.matches('form[name="new-user-registration"]')) {
        initRegisterForm(root);
    }
};

$(document).ready(() => {
    daz.initRegisterForms();
});
